import observe from "./generators/observe.js";
export default function Mutable(value) {
  var change;
  Object.defineProperties(this, {
    generator: {
      value: observe(function (_) {
        return void (change = _);
      })
    },
    value: {
      get: function get() {
        return value;
      },
      set: function set(x) {
        return change(value = x);
      }
    } // eslint-disable-line no-setter-return

  });
  if (value !== undefined) change(value);
}